import styled from 'styled-components';
import { Box, Theme } from '@material-ui/core';
import React from 'react';

const theme = (props: any) => {
  return props.theme as Theme;
}

const StyledBody = styled(Box)(props => ({
  position: 'relative',
  paddingTop: theme(props).spacing(5),
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  background: theme(props).palette.common.white,
  '&:before': {
    content: "'For Internal Use Only!'",
    color: 'red',
    fontStyle: 'italic',
    fontWeight: 'bold',
    textDecoration: 'underline',
    marginLeft: theme(props).spacing(5),
  },
})) as typeof Box;

const StyledHeaderBox = styled(Box)(props => ({
  // position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  background: 'rgba(186, 218, 154, 1)',
  height: theme(props).spacing(20),
  paddingTop: theme(props).spacing(4),
  paddingLeft: theme(props).spacing(28),
  boxShadow: '0px 8px 8px 0px #0000001f',
  zIndex: 100002,
  '&:before': {
    background: 'rgba(100, 150, 50, 1)',
    content: "url('/assets/images/chart.svg')",
    position: 'absolute',
    top: theme(props).spacing(7.75),
    left: theme(props).spacing(5),
    width: '160px',
    height: '160px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    paddingBottom: theme(props).spacing(2),
  },
})) as typeof Box;

export const AppExportBody: React.FC<{ h1?: React.ReactNode; h2?: React.ReactNode }> = ({ children, h1, h2 }) => {

  return <StyledBody>
    <StyledHeaderBox>{h1}{h2}</StyledHeaderBox>
    {children}
  </StyledBody>
};